<template>
<div class="modal print_modal" :class="{ 'open_modal': openRefundConfirmationModal}">
    <div class="modal_overlay"></div>
    <div class="modal_inner max_height_80">
        <div class="modal_header">
            <!-- <h2>환불사유를 적어주세요.</h2> -->
            <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
        </div>
        <div class="modal_wrapper">
            <div class="modal_content modal_700p">
                <div class="row">
                    <div class="col_12">
                        <div :class="['form-group', {'has_error': errorFor('refund_reason')}]">
                            <label>환불사유를 적어주세요.</label>
                            <input type="text" class="form_global" v-model="form.refund_reason">
                            <!-- <v-errors :errors="errorFor('refund_reason')" /> -->
                        </div>
                    </div>
                    <div class="col_12">
                        <div :class="['form-group', {'has_error': errorFor('refund_amount')}]">
                            <label>환불금액</label>
                            <input type="text" class="form_global" v-model="form.refund_amount">
                            <!-- <v-errors :errors="errorFor('refund_amount')" /> -->
                        </div>
                    </div>
                </div>
                <div class="common_content">
                    <div class="common_content_btn d_flex_end">
                        <button class="btn btn_blue ml_5" @click="refundAmount()">환불</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: "RefundConfirmationModal",
    components: {
        
    },
    props: {
        openRefundConfirmationModal: {
            type: Boolean,
            required: true
        },
        packageRefundAmount: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            form:{
                refund_reason : '',
                refund_amount : '',
            }
        }
    },
    watch: {
        
    },
    updated() {
       
    },
    created() {
        this.form.refund_amount = this.packageRefundAmount
    },
    methods: {
        closeModal() {
            this.$emit('closeRefundConfirmationModal')
        },
        refundAmount() {
            if(this.form.refund_amount == '' || this.form.refund_amount == 0 || (this.form.refund_amount > this.packageRefundAmount) ){
                this.allErrors = {
                    'refund_amount': 'required'
                }
            }else{
                this.allErrors = ''
                this.$emit('submitRefundConfirmation',this.form)
            }
            
        },
    }
}
</script>

<style scoped>
    .modal_header h2 {
        text-align: center;
        padding: 20px 0px;
    }
    .modal_700p {
        width: 700px;
    }
</style>
